import { connect } from 'react-redux'
import { onAccountRegDataChanged, onOrder } from '../../reducers/account'
import RegisterForm from './RegisterFormC'

const mapStateToProps = (state) => {
  let regData = state.account.regData
  if (!regData.email) {
    regData.email = state.authState.email
  }
  return {
    accountState: state.account.as,
    regData: regData
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onChange: regData => dispatch(onAccountRegDataChanged(regData)),
    onSubmit: (accounState) => dispatch(onOrder(accounState))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterForm)



// WEBPACK FOOTER //
// ./src/components/UserAccount/RegisterForm.js